//import auth0 from 'auth0-js';

let inError = false;

// // A list of values to clear from localStorage on logout.  NOTE: DO NOT clear everything since there
// // are values that are needed across logins!
// const clearValues = [
//   'access_token',
//   'id_token',
//   'expires_at',
//   'PropelUserEmail',
//   'PropelUserSubject',
//   'i18nextLng'
// ];

export default class Auth {
  constructor() {
    // const { protocol, host } = window.location;
    // const {
    //   REACT_APP_AUTH_DOMAIN,
    //   REACT_APP_AUTH_CLIENTID,
    //   REACT_APP_AUTH_AUDIENCE
    // } = process.env;

    // this.auth0 = new auth0.WebAuth({
    //   domain: REACT_APP_AUTH_DOMAIN,
    //   clientID: REACT_APP_AUTH_CLIENTID,
    //   redirectUri: `${protocol}//${host}/callback`,
    //   responseType: 'token id_token',
    //   scope: 'openid profile email',
    //   audience: REACT_APP_AUTH_AUDIENCE
    // });
    // this.scheduleRenewal();
    this.auth0 = {};
  }

  tokenRenewalTimeout;

  // scheduleRenewal() {
  //   // const expiresAt = this.expiresAt;
  //   const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
  //   const timeout = expiresAt - Date.now() - 60000; // set timeout for one minute before expiration
  //   if (timeout > 0) {
  //     this.tokenRenewalTimeout = setTimeout(() => {
  //       this.renewSession();
  //     }, timeout);
  //   }
  // }

  // getExpiryDate() {
  //   return JSON.stringify(new Date(this.expiresAt));
  // }

  login = () => {
    //this.auth0.authorize();
  };

  // renewSession() {
  //   this.auth0.checkSession({}, (err, authResult) => {
  //     if (authResult && authResult.accessToken && authResult.idToken) {
  //       this.setSession(authResult);
  //     } else if (err) {
  //       this.logout();
  //     }
  //   });
  // }

  handleAuthentication() {
    // return new Promise((resolve, reject) => {
    //   this.auth0.parseHash((err, authResult) => {
    //     if (authResult && authResult.accessToken && authResult.idToken) {
    //       inError = false;
    //       this.setSession(authResult);
    //       resolve(authResult);
    //     } else if (err) {
    //       inError = true;
    //       reject(err);
    //     }
    //   });
    // });
    return new Promise((resolve, reject) => {
      resolve({
        accessToken: 'dummyAccessToken',
        idToken: 'dummyIdToken',
      });
    });
  }

  // setSession = authResult => {
  //   // Set the time that the access token will expire at
  //   const expiresAt = JSON.stringify(
  //     authResult.expiresIn * 1000 + new Date().getTime()
  //   );
  //   localStorage.setItem('access_token', authResult.accessToken);
  //   localStorage.setItem('id_token', authResult.idToken);
  //   localStorage.setItem('expires_at', expiresAt);
  //
  //   //I think we'll want this for later use?
  //   localStorage.setItem('PropelUserEmail', authResult.idTokenPayload.email);
  //   localStorage.setItem('PropelUserSubject', authResult.idTokenPayload.sub);
  //
  //   this.auth0.client.userInfo(authResult.accessToken, (err, profile) => {
  //     if (profile) {
  //       this.userProfile = profile;
  //     }
  //     //cb(err, profile);
  //   });
  //
  //   this.scheduleRenewal();
  // };

  logout = () => {
    // const { REACT_APP_AUTH_CLIENTID, REACT_APP_AUTH_DOMAIN } = process.env;
    // const { protocol, host } = window.location;
    //
    // for (let x = 0, len = clearValues.length; x < len; x++) {
    //   localStorage.removeItem(clearValues[x]);
    // }
    //
    // // nothing in session storage should hang around after a logout
    // sessionStorage.clear();
    //
    // // Clear token renewal timeout
    // clearTimeout(this.tokenRenewalTimeout);
    //
    // window.location.replace(
    //   `https://${REACT_APP_AUTH_DOMAIN}/v2/logout?returnTo=` +
    //     `${protocol}//${host}&client_id=${REACT_APP_AUTH_CLIENTID}`
    // );
  };

  isAuthenticated = () => {
    // const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    // return new Date().getTime() < expiresAt;
    return true;
  };

  isInError = () => inError;
}
